// extracted by mini-css-extract-plugin
export var cartIcon = "_jj-0";
export var cartIconContainer = "_jj-1";